import { createContext } from 'react';

export const DrawerContext = createContext<boolean>(false);
